export const FETCH_GROUPS = 'organizations/users/groups/FETCH'
export const FETCH_GROUPS_SUCCESS = `${FETCH_GROUPS}_SUCCESS`
